import * as React from 'react';

import type { LandingPageV2Props } from 'cms';
import type { CacheSafeGetServerSideProps } from 'declarations/shared/serverSideProps';
import type { WithRouterProps } from 'next/dist/client/with-router';
import { withRouter } from 'next/router';
import type { NextRouter } from 'next/router';

import AccountFormPage from '../components/account/AccountFormPage';
import ReduxWrapper from '../components/shared/ReduxWrapper';
import LandingPageV2Layout, { getLandingpageV2ServerSideProps } from './shared/LandingPageV2Layout';

const pickString = (value: string | string[] | undefined): string | undefined =>
  Array.isArray(value) ? value[0] : value;

const Login: React.FC<NextRouter> = (props) => {
  const { config, redirectTo, emailPrefill, updatedPassword } = props.query;
  return (
    <AccountFormPage
      config={pickString(config) as 'resaleClosingDashboard' | undefined}
      redirectTo={pickString(redirectTo)}
      emailPrefill={pickString(emailPrefill)}
      updatedPassword={pickString(updatedPassword) === 'true'}
    />
  );
};

export const getServerSideProps: CacheSafeGetServerSideProps<LandingPageV2Props> = async (
  context,
) => {
  //Setting the Slug to fetch the landing Page from Contentful.
  context.params = {
    slug: 'login',
  };

  context.query.slug = 'login';
  return getLandingpageV2ServerSideProps(context);
};

export default withRouter(
  (context: React.PropsWithChildren<WithRouterProps> & LandingPageV2Props) => {
    return (
      <ReduxWrapper>
        <LandingPageV2Layout {...context}>
          <Login {...context.router} />
        </LandingPageV2Layout>
      </ReduxWrapper>
    );
  },
);
